module.exports = __webpack_public_path__ + "img/bx-qapaper-active.305b4ad5.svg";